/**
 * Resolves assistant message text from streamed chunks and/or stream final metadata
 * (legacy flat payloads use `response` instead of chunked `content`).
 */
export function resolveBradleyAssistantContent(streamedText, metadata = {}) {
  const streamed = typeof streamedText === 'string' ? streamedText : ''
  if (streamed.trim()) {
    return streamed
  }

  const fromMetadata = metadata?.content ?? metadata?.response
  return typeof fromMetadata === 'string' ? fromMetadata : ''
}

export function buildBradleyAssistantMessage(metadata = {}, streamedText = '') {
  return {
    message_id: metadata?.message_id || `assistant-${Date.now()}`,
    is_user: false,
    content: resolveBradleyAssistantContent(streamedText, metadata),
    timestamp: new Date().toISOString(),
    documents: Array.isArray(metadata?.documents) ? metadata.documents : [],
    query: metadata?.query ?? null,
    plotly_figure: metadata?.plotly_figure ?? null,
    agent_type: 'assistant',
  }
}

export function normalizeBradleyMessage(message) {
  if (!message || typeof message !== 'object') {
    return message
  }

  const hasContent = typeof message.content === 'string' && message.content.length > 0
  if (hasContent || typeof message.response !== 'string') {
    return message
  }

  return { ...message, content: message.response }
}

export function normalizeBradleyMessages(messages) {
  if (!Array.isArray(messages)) {
    return []
  }

  return messages.map(normalizeBradleyMessage)
}
